<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import TabNav from "@/components/TabNav.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { computed } from "vue";
import { RouterLink, RouterView } from "vue-router";
import { useGetHouse } from "./housesCrud";

const props = defineProps<{
  houseId: number;
}>();

const { house, getHouseStatus } = useGetHouse(props.houseId);

const houseTitle = computed(
  () => house.value?.street + " " + house.value?.houseNumber,
);
</script>
<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Häuser', to: { name: 'houses' } },
      { label: houseTitle },
    ]"
  >
    <template #header>
      <h1>{{ houseTitle }}</h1>
    </template>
    <HandleQueryStatus :query-status="getHouseStatus">
      <TabNav>
        <li>
          <RouterLink
            :to="{ name: 'editHouse', params: { houseId: props.houseId } }"
            >Allgemeine Daten</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{ name: 'houseContacts', params: { houseId: props.houseId } }"
            >Kontakte</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{
              name: 'houseConversations',
              params: { houseId: props.houseId },
            }"
            >Gespräche</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{ name: 'houseComments', params: { houseId: props.houseId } }"
            >Kommentare</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{ name: 'houseCanvasses', params: { houseId: props.houseId } }"
            >Haustüraktionen</RouterLink
          >
        </li>
      </TabNav>
      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component" :house="house"></component>
        </KeepAlive>
      </RouterView>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
